import script from "./DemoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoPage.vue?vue&type=script&setup=true&lang=js"

import "./DemoPage.vue?vue&type=style&index=0&id=48f9a844&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f9a844"]])

export default __exports__